import React, { useState } from "react";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import DatePicker from "react-datepicker";
import {
  BlockHead,
  BlockTitle,
  BlockHeadContent,
  Button,
  PreviewCard,
  Block,
  Icon,
} from "../../components/Component";
import { Row, Col, Label, Form } from "reactstrap";
import classNames from "classnames";
import useEventForm from "./form/use-event-form";
import { useParams } from "react-router";
import Dropzone from "react-dropzone";
import { Controller } from "react-hook-form";

const DateItemPicker = ({ index, control, item, errors, fields, remove }) => {
  return (
    <div
      key={item.id}
      style={{
        display: "flex",
        alignItems: "start",
        justifyContent: "space-between",
      }}
    >
      <Col md="3">
        <div className="form-group">
          <Label className="form-label" htmlFor="start-date">
            Start Date
          </Label>
          <Controller
            name={`dates[${index}].start.date`}
            control={control}
            render={({ field }) => (
              <div>
                <div className="form-control-wrap">
                  <div className="input-group">
                    <DatePicker
                      {...field}
                      selected={field.value}
                      onChange={(date) => field.onChange(date)}
                      showTimeCaption={false}
                      dateFormat="dd/MM/yyyy"
                      className="form-control date-picker"
                    />
                  </div>
                </div>
                {errors.dates &&
                  errors.dates[index] &&
                  errors.dates[index].start &&
                  errors.dates[index].start.date && (
                    <span className="invalid-message">
                      {errors.dates[index].start.date.message}
                    </span>
                  )}
              </div>
            )}
          />
        </div>
      </Col>
      <Col md="3">
        <div className="form-group">
          <Label className="form-label" htmlFor="start-time">
            Start Time
          </Label>
          <Controller
            name={`dates[${index}].start.time`}
            control={control}
            render={({ field }) => (
              <div>
                <div className="form-control-wrap">
                  <input
                    {...field}
                    type="time"
                    step={900}
                    value={field.value || ""}
                    onChange={(e) => field.onChange(e.target.value || null)}
                    className="form-control"
                  />
                </div>
                {errors.dates &&
                  errors.dates[index] &&
                  errors.dates[index].start &&
                  errors.dates[index].start.time && (
                    <span className="invalid-message">
                      {errors.dates[index].start.time.message}
                    </span>
                  )}
              </div>
            )}
          />
        </div>
      </Col>
      <Col md="3">
        <div className="form-group">
          <Label className="form-label" htmlFor="end-date">
            End Date
          </Label>
          <Controller
            name={`dates[${index}].end.date`}
            control={control}
            render={({ field }) => (
              <div>
                <div className="form-control-wrap">
                  <div className="input-group">
                    <DatePicker
                      {...field}
                      selected={field.value}
                      onChange={(date) => field.onChange(date)}
                      showTimeCaption={false}
                      dateFormat="dd/MM/yyyy"
                      className="form-control date-picker"
                    />
                  </div>
                </div>
                {errors.dates &&
                  errors.dates[index] &&
                  errors.dates[index].end &&
                  errors.dates[index].end.date && (
                    <span className="invalid-message">
                      {errors.dates[index].end.date.message}
                    </span>
                  )}
              </div>
            )}
          />
        </div>
      </Col>
      <Col md="3">
        <div className="form-group">
          <Label className="form-label" htmlFor="end-time">
            End Time
          </Label>
          <Controller
            name={`dates[${index}].end.time`}
            control={control}
            render={({ field }) => (
              <div>
                <div className="form-control-wrap">
                  <input
                    {...field}
                    type="time"
                    step={900}
                    value={field.value || ""}
                    onChange={(e) => field.onChange(e.target.value || null)}
                    className="form-control"
                  />
                </div>
                {errors.dates &&
                  errors.dates[index] &&
                  errors.dates[index].end &&
                  errors.dates[index].end.time && (
                    <span className="invalid-message">
                      {errors.dates[index].end.time.message}
                    </span>
                  )}
              </div>
            )}
          />
        </div>
      </Col>
      <Icon
        name="trash"
        style={{ marginTop: 40, cursor: "pointer" }}
        onClick={() => remove(index)}
        disabled={fields.length === 1}
      ></Icon>
    </div>
  );
};

const EditEventPage = () => {
  const { id } = useParams();
  const event = {
    title: "nguyedinhan",
    desc:
      "Excepteur aute sunt officia consequat ipsum enim ex sunt id mollit eu aliquip nulla. Ut excepteur ea enim mollit sunt consequat est ipsum occaecat. Exercitation sint id aliqua ex ad irure labore quis sint Lorem cillum ea adipisicing reprehenderit. Nostrud aute sit ullamco minim voluptate cillum veniam deserunt Lorem velit cillum sit sit proident.",
    dates: [
      {
        start: { date: "2024-01-22T02:36:48.432Z", time: "09:00" },
        end: { date: "2024-03-22T02:36:48.432Z", time: "18:00" },
      },
    ],
    location: "WK",
  };
  const [files, setFiles] = useState([]);
  const handleDropChange = (acceptedFiles, onChange) => {
    onChange(
      acceptedFiles.map((file) =>
        Object.assign(file, { preview: URL.createObjectURL(file) })
      )
    );
  };
  const { fields, append, remove, form, control, onFormSubmit } =
    useEventForm(event);
  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = form;
  const formClass = classNames({
    "form-validate": true,
    "is-alter": true,
  });
  return (
    <React.Fragment>
      <Head title={"Edit Event"}></Head>
      <Content>
        <BlockHead size="sm">
          <BlockHeadContent>
            <BlockTitle>Edit Event</BlockTitle>
          </BlockHeadContent>
        </BlockHead>
        <Block>
          <PreviewCard className="h-100">
            <Form className={formClass} onSubmit={handleSubmit(onFormSubmit)}>
              <Row className="g-gs">
                <Col md="12">
                  <div className="form-group">
                    <Label className="form-label" htmlFor="fv-title">
                      Title
                    </Label>
                    <div className="form-control-wrap">
                      <input
                        type="text"
                        id="fv-title"
                        {...register("title")}
                        className="form-control"
                      />
                      {errors.title && (
                        <span className="invalid">{errors.title.message}</span>
                      )}
                    </div>
                  </div>
                </Col>
                <Col md="12">
                  <div className="form-group">
                    <Label className="form-label" htmlFor="fv-desc">
                      Description
                    </Label>
                    <div className="form-control-wrap">
                      <textarea
                        type="textarea"
                        className="form-control form-control-sm"
                        id="fv-desc"
                        {...register("desc")}
                      />
                      {errors.desc && (
                        <span className="invalid">{errors.desc.message}</span>
                      )}
                    </div>
                  </div>
                </Col>
                {fields.map((item, index) => (
                  <DateItemPicker
                    key={index}
                    index={index}
                    control={control}
                    item={item}
                    errors={errors}
                    fields={fields}
                    remove={remove}
                  />
                ))}
                <div className="align-center flex-wrap flex-sm-nowrap">
                  <Button
                    color="primary"
                    size="md"
                    type="button"
                    onClick={() =>
                      append({
                        start: { date: null, time: null },
                        end: { date: null, time: null },
                      })
                    }
                  >
                    Add date
                  </Button>
                  {errors.dates && (
                    <span className="invalid-message" style={{ marginLeft: 10 }}>
                      {errors.dates.message}
                    </span>
                  )}
                </div>
                <Col md="6">
                  <div className="form-group">
                    <Label className="form-label" htmlFor="fv-location">
                      Location
                    </Label>
                    <div className="form-control-wrap">
                      <input
                        type="text"
                        id="fv-location"
                        {...register("location")}
                        className="form-control"
                      />
                      {errors.location && (
                        <span className="invalid">
                          {errors.location.message}
                        </span>
                      )}
                    </div>
                  </div>
                </Col>
                <Col md="6">
                  <div className="form-group">
                    <Label className="form-label" htmlFor="fv-link">
                      Link
                    </Label>
                    <div className="form-control-wrap">
                      <input
                        type="text"
                        id="fv-link"
                        {...register("link")}
                        className="form-control"
                      />
                      {errors.link && (
                        <span className="invalid">{errors.link.message}</span>
                      )}
                    </div>
                  </div>
                </Col>
                <Col sm="12">
                  <label className="form-label">Image</label>
                  <Dropzone
                    accept={[".jpg", ".jpeg", ".png", ".svg"]}
                    onDrop={(acceptedFiles) =>
                      handleDropChange(acceptedFiles, setFiles)
                    }
                  >
                    {({ getRootProps, getInputProps }) => (
                      <section>
                        <div
                          {...getRootProps()}
                          className="dropzone upload-zone dz-clickable"
                        >
                          <input {...getInputProps()} />
                          {files.length === 0 && (
                            <div className="dz-message">
                              <span className="dz-message-text">
                                Drag and drop image
                              </span>
                              <span className="dz-message-or">or</span>
                              <Button color="primary" type="button">
                                SELECT
                              </Button>
                            </div>
                          )}
                          {files.map((file) => (
                            <div
                              key={file.name}
                              className="dz-preview dz-processing dz-image-preview dz-error dz-complete"
                            >
                              <div className="dz-image">
                                <img
                                  src={file.preview}
                                  alt="preview"
                                  width={120}
                                  height={120}
                                  style={{
                                    objectFit: "cover",
                                  }}
                                />
                              </div>
                            </div>
                          ))}
                        </div>
                      </section>
                    )}
                  </Dropzone>
                </Col>
                <Col md="12">
                  <div className="form-group">
                    <Button color="primary" size="lg" type="submit">
                      Save
                    </Button>
                  </div>
                </Col>
              </Row>
            </Form>
          </PreviewCard>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default EditEventPage;
